import { useEffect } from "react";
import ButtonIconH from "./ButtonIconH";
import "../css/PopupMessage.css";

export default function PopupMessage(props) {
  const handlers = [
    props.onClickAccept,
    props.onClickCancel,
    props.onClickExtra1,
    props.onClickExtra2,
  ].filter(Boolean);

  useEffect(() => {
    if (handlers.length !== 1) {
      return;
    }

    const onKeyDown = (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        e.stopPropagation();
        handlers[0]();
      }
    };

    document.addEventListener("keydown", onKeyDown, true);
    return () => document.removeEventListener("keydown", onKeyDown, true);
  }, [
    props.onClickAccept,
    props.onClickCancel,
    props.onClickExtra1,
    props.onClickExtra2,
  ]);

  return (
    <div className="popup-container popup-container-extra info-popup">
      <div className="popup-message">
        <span className="popup-text">{props.text}</span>
        {(props.onClickAccept ||
          props.onClickCancel ||
          props.onClickExtra1 ||
          props.onClickExtra2) && (
          <div className="popup-buttons">
            {props.onClickAccept && (
              <ButtonIconH
                text={!props.textAccept ? "Sí" : props.textAccept}
                onClick={() => {
                  props.onClickAccept();
                }}
              />
            )}
            {props.onClickCancel && (
              <ButtonIconH
                text={!props.textCancel ? "No" : props.textCancel}
                onClick={() => {
                  props.onClickCancel();
                }}
              ></ButtonIconH>
            )}
            {props.onClickExtra1 && (
              <ButtonIconH
                text={!props.textExtra1 ? "Extra" : props.textExtra1}
                onClick={() => {
                  props.onClickExtra1();
                }}
              ></ButtonIconH>
            )}
            {props.onClickExtra2 && (
              <ButtonIconH
                text={!props.textExtra2 ? "Extra" : props.textExtra2}
                onClick={() => {
                  props.onClickExtra2();
                }}
              ></ButtonIconH>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
